import PeriodeService from '../services/periode.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

export const periodeModule = {
  namespaced: true,

  actions: {
    async getPeriodesForEntreprise ({ commit }, recherchePeriode) {
      return PeriodeService.getPeriodesForEntreprise(recherchePeriode).then(
        response => {
          const periodes = response.data.periodeDebitCreditGestList
          return Promise.resolve(periodes)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async updatePeriode ({ commit }, updatePeriode) {
      return PeriodeService.updatePeriode(updatePeriode).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async deletePeriode ({ commit }, periodToDelete) {
      return PeriodeService.deletePeriode(periodToDelete).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getDatesForPeriode ({ commit }) {
      return PeriodeService.getDatesForPeriode().then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createPeriode ({ commit }, periodeBean) {
      return PeriodeService.createPeriode(periodeBean).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    }
  }
}
